import {atom} from "recoil";

export const stateIsExternalLoad = atom<boolean>({
    key: 'isExternalLoad',
    default: !!window.__CONSTRUCTOR_STATE__,
});


